<div class="home-container">
    <app-header></app-header>
    <div class="home-body">
        <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
</div>